import baseAPI from "@/http";

const router = "api/municipio-escola";

export const municipioEscolaApi = {
  list: (codigoIbge) =>
    baseAPI.get(
      `${router}/obter-municipio-escola-por-codigoIbge?codigoIbge=${codigoIbge}`
    ),
  create: (escola) => baseAPI.post(`${router}`, escola),
  update: (escola) => baseAPI.put(`${router}`, escola),
  delete: (escolaId) => baseAPI.delete(`${router}?id=${escolaId}`),
};
